<template>
  <div>
    <div class="row row-inside">
      <div class="flex md12">
        <va-card title="Gestion des prélèvements">
          <div class="row row-inside">
            <div class="flex md6">
              <div class="row row-inside">
                <div class="flex md1">
                  <va-button
                    class="fullwidth"
                    v-if="years.length > 3"
                    color="info"
                    icon="fa fa-arrow-circle-o-left"
                    :disabled="startYear === 0"
                    @click="startYear = startYear - 1"
                  />
                </div>
                <div class="flex md2" v-for="year in yearsDisplay">
                  <va-button
                    :color="activeYear === year ? 'success' : 'info'"
                    class="fullwidth"
                    @click="activeYear = year"
                    >{{ year }}</va-button
                  >
                </div>
                <div class="flex md1">
                  <va-button
                    v-if="years.length > 3"
                    color="info"
                    icon="fa fa-arrow-circle-o-right"
                    :disabled="startYear === years.length - 3"
                    @click="startYear = startYear + 1"
                  />
                </div>
              </div>
            </div>
            <div class="flex md2 offset--md1">
              <va-input
                :value="nomRe"
                :placeholder="$t('poissonnierTable.searchByName')"
                removable
                @input="searchNom"
              />
            </div>
            <div class="flex md3">
              <va-button-toggle
                outline
                small
                color="info"
                class=""
                v-model="showPrelevementType"
                :options="optionsPrelevement"
              />
            </div>
          </div>
          <div
            class="row row-inside"
            v-for="(trimesterStart, index) in trimesterList"
            :key="index"
          >
            <div class="flex md12">
              <prelevements-trimestre
                ref="prelevementtrimestre"
                :trimestreStart="trimesterStart"
                :key="update"
                :filter="showPrelevementType"
                :filterText="nomRe"
                @showEntreprise="showEntreprise"
              />
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <dashboard-fiche-entreprise
      v-model="showFicheEntreprise"
      :tableentreprise="entreprise"
      @update="updateEntreprise"
    />
  </div>
</template>

<script>
import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import DashboardFicheEntreprise from "../dashboard/DashboardFicheEntreprise";
import moment from "moment";
import axios from "axios";

import PrelevementsTrimestre from "./PrelevementsTrimestre";

export default {
  components: { PrelevementsTrimestre, DashboardFicheEntreprise },
  data() {
    return {
      nomRe: null,
      update: 0,
      entreprise: null,
      showFicheEntreprise: false,
      searchField: "",
      activeYear: moment().year(),
      startYear: 0,
      years: [],
      pages: [],
      optionsPrelevement: [
        { label: "Tous", value: "all" },
        { label: "Annuels", value: "year" },
        { label: "Trimestriels", value: "quarter" },
      ],
      showPrelevementType: "all",
    };
  },
  mounted() {
    this.getMinYear()
      .then((result) => {})
      .catch((err) => {});
  },
  methods: {
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    async updateEntreprise(stuff) {
      console.log("stuff", stuff);
      // reload all list to conform with new database state
      // save page state and reapply probably should use vuex for this type of interaction
      let pages = [];
      for (let ijk = 0; ijk < this.$refs.prelevementtrimestre.length; ijk++) {
        pages.push(this.$refs.prelevementtrimestre[ijk].currentPage);
      }
      await this.getMinYear();
      this.update += 1;
      //reapply pages
      this.switchPage(pages);
    },
    switchPage: debounce(function (pages) {
      console.log("pages", pages, this.$refs.prelevementtrimestre.length);
      // todo better method can be made with props and checking that the component is mounted
      for (let ijk = 0; ijk < pages.length; ijk++) {
        console.log("test");
        this.$refs.prelevementtrimestre[ijk].switchPage(pages[ijk]);
      }
    }, 200),
    showEntreprise(entreprise) {
      this.entreprise = entreprise;
      this.showFicheEntreprise = true;
    },
    async getMinYear() {
      try {
        let results = await axios.get("/api/prelevements/years");
        this.years = results.data;
        this.startYear = this.years.length - 3;
        return 1;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    searchList: debounce(function (searchField) {
      this.searchField = searchField;
    }, 400),
  },
  computed: {
    trimesterList() {
      // note: trimester becomes available 2 weeks before start
      let list = [];
      let listTri = ["-01-01", "-04-01", "-07-01", "-10-01"];
      listTri.forEach((element) => {
        if (
          moment().isAfter(
            moment(this.activeYear + element, "YYYY-MM-DD").subtract(2, "weeks")
          )
        ) {
          list.push(this.activeYear + element);
        }
      });
      return list;
    },
    yearsDisplay() {
      if (this.years.length > 3) {
        return this.years.slice(this.startYear, this.startYear + 3);
      } else {
        return this.years;
      }
    },
  },
};
</script>

<style scoped>
.fullwidth {
  width: 95%;
}
</style>
